var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8395 6.04318C19.194 6.04318 12.1797 12.7193 12.1797 20.9417C12.1797 30.4029 22.6195 45.396 26.4529 50.5746C26.6121 50.7932 26.8206 50.9711 27.0616 51.0937C27.3025 51.2164 27.5691 51.2803 27.8395 51.2803C28.1099 51.2803 28.3764 51.2164 28.6174 51.0937C28.8583 50.9711 29.0669 50.7932 29.226 50.5746C33.0594 45.3982 43.4993 30.4105 43.4993 20.9417C43.4993 12.7193 36.485 6.04318 27.8395 6.04318Z",
    stroke: "#4E5866",
    strokeWidth: 3.47995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.8396 26.923C30.7224 26.923 33.0595 24.5859 33.0595 21.7031C33.0595 18.8202 30.7224 16.4831 27.8396 16.4831C24.9567 16.4831 22.6196 18.8202 22.6196 21.7031C22.6196 24.5859 24.9567 26.923 27.8396 26.923Z",
    stroke: "#4E5866",
    strokeWidth: 3.47995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location-outline.014c1ef1974e61bf72ea8858fa4308d9.svg";
export { ForwardRef as ReactComponent };